module.exports = {
  "/": {
    "success": {
      "default": [
        "root"
      ]
    },
    "error": [
      "ERROR_PAGE"
    ]
  },
  "/callout": {
    "success": {
      "default": [
        "callout"
      ]
    },
    "error": [
      "ERROR_PAGE"
    ]
  },
  "/question": {
    "success": {
      "default": [
        "question"
      ]
    },
    "error": [
      "ERROR_PAGE"
    ]
  },
  "/follow_up": {
    "success": {
      "default": [
        "follow_up"
      ]
    },
    "error": [
      "ERROR_PAGE"
    ]
  },
  "/thank_you": {
    "success": {
      "default": [
        "thank_you"
      ]
    },
    "error": [
      "ERROR_PAGE"
    ]
  }
};